import { Capacitor } from '@capacitor/core'
import { Share } from '@capacitor/share'
import { useIonAlert } from '@ionic/react'

type ShareUrlArgs = {
	url: string
	title?: string
	presentAlert: ReturnType<typeof useIonAlert>[0]
}

export async function shareUrl(args: ShareUrlArgs) {
	const { url, title, presentAlert } = args
	const pageTitle = title || document.title

	if (Capacitor.isNativePlatform()) {
		await Share.share({
			title: pageTitle,
			url,
			dialogTitle: 'Share',
		})
		return
	}

	if (navigator?.share) {
		await navigator.share({
			title: pageTitle,
			url,
		})
		return
	}

	if (!navigator.clipboard?.writeText) {
		presentCopyFailure(url, presentAlert)
		return
	}

	try {
		await navigator.clipboard.writeText(url)
		presentAlert({
			header: 'Link Copied',
			subHeader: url,
			message: 'Paste into a message to share with others.',
			buttons: [ 'OK' ],
		})
	} catch (error) {
		console.error('Failed to copy share URL', error)
		presentCopyFailure(url, presentAlert)
	}
}

function presentCopyFailure(url: string, presentAlert: ShareUrlArgs['presentAlert']) {
	presentAlert({
		message: 'Copy this link to share with others.',
		inputs: [
			{
				type: 'textarea',
				value: url,
				attributes: {
					readonly: true,
				},
			},
		],
		buttons: [ 'OK' ],
	})
}
